<div class="wrapper">

  <button class="search-button" (click)="onSearchText()">
    <tun-menu-search-icon-v5 class="icon icon-scaled-svg-button icon-search-button"></tun-menu-search-icon-v5> {{'searchList.button.search' | translate}}
  </button>


  <!--<div class="title">{{'searchList.label.title' | translate }}</div>-->

  @if ((searchMusicChannelGroupsLoading$ | async)) {
    <tun-loader-v5 class="loader"></tun-loader-v5>
  }

  @if ((searchMusicChannelGroupsError$ | async)) {
    <div class="errorContainer">
      <p>{{'general.status.error.message' | translate}}</p>
      <button (click)="onRetry()" class="retryButton">
        <p>
          {{'general.status.error.retry' | translate }}
        </p>
      </button>
    </div>
  }

  @if (!(searchMusicChannelGroupsLoading$ | async) && !(searchMusicChannelGroupsError$ | async)) {
    <div class="scrollContainer">
      @for (searchMusicChannel of (searchMusicChannels$ | async); track searchMusicChannel; let i = $index) {
        <tun-search-music-channel-large-view
          class="musicChannel {{ i == 0 ? 'first' : ''}}"
          [searchMusicChannel]="searchMusicChannel"
          [hexColor]="colorForIndex(i)"
          >
        </tun-search-music-channel-large-view>
      }
    </div>
  }

</div>
